import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import DoneIcon from '@material-ui/icons/Done';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles as styles } from '../../core/style/gstheme';

class QuickFilter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: ""
    };
    this.textInput = React.createRef();
  }

  filterLabel = (event) => this.setState({ text: event.target.value });

  clearFilter = () => {
    this.setState({ text: "" });
    this.textInput && this.textInput.current && this.textInput.current.focus();
  };

  applyFilter = (ev) => {
    const exactMatch = ev.ctrlKey;
    this.props.onAddFilter(this.props.property, this.state.text.trim(), exactMatch);
  };

  reset = () => this.setState({ text: "" });

  render() {

    const { text } = this.state;
    const { classes, placeholder, maxLength, dataTest } = this.props;

    return (
      <div>
        <ClickAwayListener onClickAway={this.reset}>
          <TextField
            data-test="filter"
            fullWidth margin="dense"
            id="text"
            name="quick-text"
            value={text}
            inputRef={this.textInput}
            style={{ marginTop: '0px' }}
            variant="outlined"
            onKeyPress={(ev) => {
              if (text !== "" && text.length > 1 && ev.charCode === 13) {
                this.applyFilter(ev);
                ev.preventDefault();
                ev.stopPropagation();
              }
            }}
            placeholder={placeholder || "Quick filter"}
            onChange={this.filterLabel}
            InputLabelProps={{
              className: classes.inputLabel
            }}
            InputProps={{
              className: classes.inputLabel,
              inputProps: {
                "data-test": dataTest,
                maxLength: maxLength
              },
              ...(text !== "" && text.length > 1) && {
                endAdornment:
                  <InputAdornment position="end">
                    <Tooltip title="Add filter">
                      <span>
                        {text !== "" ?
                          <DoneIcon data-test="add-filter-icon" className={classes.inputIconHighlighted} onClick={this.applyFilter} />
                          :
                          null
                        }
                      </span>
                    </Tooltip>
                  </InputAdornment>
              }
            }}
          />
        </ClickAwayListener>
      </div>
    );
  }

}

QuickFilter.defaultProps = {
  includeLabel: false,
  altered: false,
  dataTest: "quick-filter",
  label: "Filter",
  minLength: 0,
  maxLength: 30
};

QuickFilter.propTypes = {
  dataTest: PropTypes.string,
  onAddFilter: PropTypes.func.isRequired,
  altered: PropTypes.bool,
  exclude: PropTypes.array,
  property: PropTypes.string,
  label: PropTypes.string,
  includeLabel: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  classes: PropTypes.object
};

export default withStyles(styles)(QuickFilter);